import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getContactInformation() {
  return apiRequest('/api/contact_information', {
    method: 'GET',
    allowNotFound: true,
  });
}

export async function submitContactRequest({ fullName, mobile, email, message }) {
  return apiRequest('/api/contact_requests', {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({
      full_name: fullName,
      mobile_number: mobile,
      email,
      message,
    }),
  });
}
